import React, {useEffect, useState} from 'react';
import i18n from '../../i18n';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import FormField from '../Form/FormField';
import Grid from '@material-ui/core/Grid/Grid';
import DeleteButton from '../Form/DeleteButton';
import FormSelect from '../Form/FormSelect';
import FormAutocompleteGQL from '../Form/FormAutocompleteGQL';
import projectQueries from '../../queries/projectQueries';
import {getSelectOptionEntity} from '../Form/utils';
import moment from 'moment-business-days';
import buildingQueries from "../../queries/buildingQueries";
import contactQueries from "../../queries/contactQueries";
import swal from "sweetalert";
import {fileType} from "../Utilities";
import _ from 'lodash';
import ButtonMakePDF from "../File/PDF/ButtonMakePDF";

/**
 *
 * @param {*} codeTemplate
 * @param {string} prefix
 * @param {string} suffix
 * @returns {*}
 */
const calcProjectNumber = (codeTemplate, prefix, suffix) => {
    codeTemplate = codeTemplate.replace('%prefix%', prefix || '');
    codeTemplate = codeTemplate.replace('%suffix%', suffix ? '-' + suffix :'');
    return codeTemplate;
};

const showAlert = (option, hasParent) => {

    let object = i18n.get('building.self');

    let swAlConfig = {
        title: hasParent
            ? i18n.get('default.select.create_option',{object:object, option:option}) + '?'
            : i18n.get('project.deficiency.msg.title_select_parent'),
        text: i18n.get(hasParent
            ? 'default.you_will_be_redirected'
            : 'project.deficiency.msg.text_select_parent'),
        dangerMode: !hasParent,
    };
    if(hasParent) {
        swAlConfig.buttons = {
            cancel:i18n.get('default.cancel'),
            create:i18n.get('default.create'),
        }
    }
    // if calling this method the caller needs a 'then'-callback because 'swal' required this
    return swal(swAlConfig);
}

const openCompletionDialog = (type) => {
    type = i18n.get('deficiency.pdf.' + type);
    return swal({
        title: i18n.get('deficiency.pdf.completion_dialog_title',{type: type || ''}),
        text: i18n.get('deficiency.pdf.complete_history_request'),
        buttons: {
            cancel: 'Abbrechen',
            deny: {
                text: 'Nein',
            },
            confirm: {
                text: 'Ja',
                value: 'confirm'
            },
        }
    });
}
const openRenderDialog = (type) => {
    type = i18n.get('deficiency.pdf.' + type);
    return swal({
        text: i18n.get('deficiency.pdf.render_dialog_title',{type: type || ''}),
        button: {
            text: "ok",
            closeModal: false,
        },
        closeOnClickOutside: false,
        closeOnEsc: false,
        allowOutsideClick: false,
    });
}

const changeProjectStatus = async (event) => {
    let query = projectQueries.getProjectStatus;
    let variables = {event:event};
    const {data: status} =  await window.apolloClient.query({ query, variables });
    return status['projectstatus'];
}

const isWarrantyPeriodExpired = (option) => {
    const periodEnd = option && option.entity && option.entity.warranty_period_end;
    return periodEnd && moment().isAfter(periodEnd);
}

const isDateExpired = date => {
    return date && moment().isAfter( date);
}

/**
 * @param values
 * @param touched
 * @param errors
 * @param handleChange
 * @param handleBlur
 * @param setFieldValue
 * @param classes
 * @param formUrl
 * @param isSubmitting
 * @param buildedProjectNumber
 * @param defaultStatus
 * @param handleOpen
 * @param props
 */
const FormFields = ({
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        setFieldValue,
        classes,
        formUrl,
        isSubmitting,
        isValid,
        builtProjectNumber,
        defaultStatus,
        handleOpen,
        handleSubmit,
        requestState,
        isComplete,
        ...props
    },
) => {

    const [subordinates,setSubordinates] = useState(values.building_parent
        ? values.building_parent.children
        : []
    );
    const [saveOnly,setSaveOnly] = useState(false);
    const [numberInternal] = useState(values.number_internal ||
        calcProjectNumber(
            builtProjectNumber,
            values.custom_number.prefix,
            values.custom_number.suffix
        )
    );
    const [status,setStatus] = useState(values.status || defaultStatus);
    //const [dateChanged,setDateChanged] = useState(false);
    const [reminder,setReminder] = useState(values.reminder || '');
    const dayOfReminder = 1;

    const changeStatus = status => {
        let oldStatus = _.cloneDeep(values.status);
        setFieldValue('status_id',status.id);
        setFieldValue('status',status);
        setStatus(status);
        // remove date 'defects_eliminated'
        oldStatus.event === 'defects_eliminated' && setFieldValue('defects_eliminated','');
    }

    const calculateReminder = (deadline,diff) => {
        deadline = moment(deadline);
        if(deadline.isValid()){
            deadline = deadline.businessAdd(diff)._d;
            setReminder(moment(deadline).format('YYYY-MM-DD'));
            return true;
        }
        return false;
    }

    useEffect(() => {
        setFieldValue('reminder', reminder);
        setFieldValue('number_internal',numberInternal);
    },[reminder,numberInternal]);

    // creating new building
    const handleCreateBuilding = (option) => {
        let newKey = Math.floor(Math.random() * 1000000);

        showAlert(option, !!values.building_parent_id).then((event) =>{
            if(event === 'create'){
                setSubordinates([...subordinates,{name:option + ' *',id:newKey}]);
                setFieldValue('building_child_id',newKey);
                setFieldValue('building_child_name',option);
                window.open(
                     `/construction/create?parent=${values.building_parent_id}&building=${option}`,
                     '_blank');
            }
        });
    }

    const handleDialog = () => {
        let type = fileType(values);
        openCompletionDialog(type).then(res => {
            switch (res) {
                case 'confirm':
                    handleOpen();
                    break;
                case 'deny':
                    openRenderDialog(type)
                        .then(res => (res && requestState(true)));
                    break;
                default:
                    setFieldValue('submitting',false);
                    props.setSubmitting(false);
                    break;
            }
        })
    }

    useEffect(()=> {
        let type = fileType(values);
        setFieldValue('save_only',saveOnly);
        if(isSubmitting && isValid && !isComplete && !saveOnly) {
            setFieldValue('submitting',true);
            if(values.correspondence) {
                openRenderDialog(type).then( res => {
                    props.setSubmitting(false);
                    res && requestState(true);
                })
            } else {
                handleDialog(type);
            }
        }
    },[isSubmitting,isValid,isComplete,saveOnly]);

    const [withdrawalOrder,setWithdrawalOrder] = useState(false);
    useEffect(() => {
        if(isDateExpired(values.second_grace_period) && status.event !== 'second_grace_period') {
            let title = i18n.get('deficiency.events.second_grace_period');
            let text = i18n.get('deficiency.dialog.status_update');
            changeProjectStatus('second_grace_period').then( status => {
                swal({
                    title: title,
                    text:text,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    allowOutsideClick: false,
                }).then(e=>{
                    if(e) {
                        setWithdrawalOrder(true);
                        changeStatus(status);
                    }
                })
            })
        }
    },[status]);

    return (
        <React.Fragment>
            <Grid container spacing={8} alignItems="center" justify="center">
                <Grid item xs={12} sm={6}>
                    <FormAutocompleteGQL
                        query={buildingQueries.findParentBuildings}
                        labelName={'name'}
                        valueName={'id'}
                        name={'building_parent_id'}
                        label={i18n.get('building.construction_project')}
                        isClearable={true}
                        error={errors.building_parent_id}
                        touched={touched.building_parent_id}
                        isOptionDisabled={isWarrantyPeriodExpired}
                        mutateData={e => ( moment().isAfter(e.warranty_period_end) ? (e.name + ' *') : e.name) }
                        onChange={selectedOption => {
                            if(selectedOption) {
                                setFieldValue('building_parent_id', selectedOption.value);
                                setFieldValue('building_parent', selectedOption.entity);
                                setSubordinates(selectedOption.entity.children || []);
                            } else {
                                setFieldValue('building_parent_id', '');
                                setFieldValue('building_parent', null);
                                setSubordinates([]);
                            }
                        }}
                        value={values.building_parent && getSelectOptionEntity( values.building_parent )}
                        disabled={ moment().isAfter(
                            values.building_parent
                            && values.building_parent.warranty_period_end
                            && values.building_parent.warranty_period_end
                        )}
                        likeLeft
                    >

                    </FormAutocompleteGQL>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormSelect
                        type="text"
                        name="building_child_id"
                        label={i18n.get('building.self_selection') + (` (${subordinates.length})` || '')}
                        isClearable={true}
                        error={errors.building_child_id}
                        touched={touched.building_child_id}
                        onChange={selectedOption => {
                            setFieldValue('building_child_id', selectedOption ? selectedOption.value : '');
                            setFieldValue('building_child_address', selectedOption ? selectedOption.address : '');
                        }}
                        options={subordinates.map(sub => {
                            return {
                                label: sub.name + ', ' + sub.street + ' ' + sub.number,
                                value: sub.id,
                                address: sub.street + ' ' + sub.number,
                            }
                        })}
                        placeholder={values.building_child_trashed
                            ? '* ' + i18n.get('building.msg.deleted',{name: values.building_child_trashed})
                            : ( subordinates.length
                                ? i18n.get('building.please_select')
                                : i18n.get('building.no_object_available') )}
                        value={values.building_child_id}
                        creatable={true}
                        newOptionLabel={i18n.get('building.self')}
                        onCreated={(option) => handleCreateBuilding(option)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormField
                        type="text"
                        name="number_client"
                        label={i18n.get('project.deficiency.number_client')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.number_client}
                        error={errors.number_client}
                        touched={touched.number_client}
                        maxLength={255}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type="text"
                        name="number_internal"
                        label={i18n.get('deficiency.number_internal',{initials: window.companyInitials ?? ''})}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={numberInternal}
                        error={errors.number_internal}
                        touched={touched.number_internal}
                        maxLength={255}
                        disabled={true}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormField
                        type="text"
                        name="name"
                        label={i18n.get('project.deficiency.name')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                        error={errors.name}
                        touched={touched.name}
                        maxLength={255}
                        autoComplete={'off'}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormAutocompleteGQL
                        query={contactQueries.findSubcontractor}
                        labelName={'company_name'}
                        valueName={'id'}
                        name="contact_id"
                        label={i18n.get('project.deficiency.subcontractor')}
                        isClearable={true}
                        mutateData={(data) => {
                            return data.company_name;
                        }}
                        onBlur={handleBlur}
                        onChange={selectedOption => {
                            setFieldValue('contact_id', selectedOption ? selectedOption.value : '');
                            setFieldValue('contact', selectedOption ? selectedOption.entity : null);
                        }}
                        value={values.contact && getSelectOptionEntity(values.contact,'company_name')}
                        error={errors.contact_id}
                        touched={touched.contact_id}
                        likeLeft
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormField
                        type="date"
                        name="client_note"
                        label={i18n.get('project.deficiency.date.client_note')}
                        error={errors.client_note}
                        touched={touched.client_note}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.client_note.substring(0, 10) }
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormAutocompleteGQL
                        query={projectQueries.allProjectStatus}
                        labelName={'name'}
                        valueName={'id'}
                        name="status_id"
                        label={i18n.get('deficiency.status')}
                        error={errors.status_id}
                        touched={touched.status_id}
                        onChange={selectedOption => {
                            setFieldValue('status', selectedOption.entity);
                            changeStatus(selectedOption.entity);
                        }}
                        defaultOptions
                        onBlur={handleBlur}
                        value={getSelectOptionEntity(status)}
                    />

                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="date"
                        name="deadline"
                        label={i18n.get('project.deficiency.date.deadline_for_completion')}
                        error={errors.deadline}
                        touched={touched.deadline}
                        onChange={(x)=>{
                            handleChange(x);
                            if( calculateReminder(x.target.value, dayOfReminder) ){
                                //setDateChanged(true);
                                changeProjectStatus('deficiency_notified').then(e => {
                                    changeStatus(e);
                                    ['first_grace_period', 'second_grace_period', 'defects_eliminated']
                                        .forEach(field => setFieldValue(field,''));
                                });
                            } else {
                                setReminder('');
                            }
                        }}
                        onBlur={handleBlur}
                        value={values.deadline.substring(0, 10)}
                        InputLabelProps={{shrink: true}}

                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="date"
                        name="first_grace_period"
                        label={i18n.get('project.deficiency.date.first_grace_period')}
                        error={errors.first_grace_period}
                        touched={touched.first_grace_period}
                        onChange={(x)=>{
                            handleChange(x);
                            if( calculateReminder(x.target.value , dayOfReminder) ) {
                                //setDateChanged(true);
                                changeProjectStatus('deadline').then(e => {
                                    changeStatus(e);
                                    ['second_grace_period', 'defects_eliminated']
                                        .forEach(field => setFieldValue(field,''));
                                });
                            }
                        }}
                        onBlur={handleBlur}
                        value={values.first_grace_period.substring(0, 10)}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="date"
                        name="second_grace_period"
                        label={i18n.get('project.deficiency.date.second_grace_period')}
                        error={errors.second_grace_period}
                        touched={touched.second_grace_period}
                        onChange={(x)=>{
                            handleChange(x);
                            if( calculateReminder(x.target.value , dayOfReminder) ) {
                                //setDateChanged(true);
                                setFieldValue('defects_eliminated','');
                                changeProjectStatus('first_grace_period').then(e => {
                                    changeStatus(e);
                                });
                            }
                        }}
                        onBlur={handleBlur}
                        value={values.second_grace_period.substring(0, 10)}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="date"
                        name="reminder"
                        label={i18n.get('project.deficiency.date.reminder')}
                        error={errors.reminder}
                        touched={touched.reminder}
                        onChange={(x) => {
                            handleChange(x);
                            setReminder(x.target.value);
                            setFieldValue('reminder',x.target.value);
                        }}
                        onBlur={handleBlur}
                        value={reminder.substring(0, 10)}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="text"
                        name="apartment_number"
                        label={i18n.get('project.deficiency.apartment_number')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.apartment_number}
                        maxLength={255}
                        error={errors.apartment_number}
                        touched={touched.apartment_number}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="text"
                        name="storey"
                        label={i18n.get('project.deficiency.storey')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.storey}
                        error={errors.storey}
                        touched={touched.storey}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="text"
                        name="tenant_name"
                        label={i18n.get('project.deficiency.tenant.name')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.tenant_name}
                        maxLength={255}
                        error={errors.tenant_name}
                        touched={touched.tenant_name}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormField
                        type="text"
                        name="tenant_phone_number"
                        label={i18n.get('project.deficiency.tenant.phone_number')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.tenant_phone_number}
                        error={errors.tenant_phone_number}
                        touched={touched.tenant_phone_number}
                    />
                </Grid>
                {values.id &&(
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="change_note"
                            label={i18n.get('project.change_note')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.change_note}
                            error={errors.change_note}
                            touched={touched.change_note}
                            maxLength={255}
                        />
                    </Grid>
                )}
            </Grid>

            {props.children}

            <Grid container spacing={24} justify="space-between"
                  alignItems="center"
                  style={{paddingTop: 8}}>
                <Grid item>
                    {values.id > 0 && (
                        <DeleteButton
                            disabled={isSubmitting}
                            href={`/project/${values.id}`}
                            confirmMessage={i18n.get(
                                'contacts.confirm_message')}
                            successMessage={i18n.get(
                                'contacts.delete_success_message')}
                            handleSuccess={() => {
                                history.go(-1);
                            }}
                        />
                    )}
                </Grid>
                <Grid item>
                    {values.building_parent && isDateExpired(values.building_parent.warranty_period_end)
                    ? (
                        <Button
                            component={'a'}
                            href={'/project'}
                            //name={'submitting'}
                            variant="contained"
                            color={'secondary'}
                            size={'small'}
                        >
                            <Icon fontSize="small">arrow_back_ios</Icon>
                            &nbsp;
                            {i18n.get('default.nav.back')}
                        </Button>
                    ) : (
                        <React.Fragment>
                            {/* {!!window.debug && <ButtonMakePDF values />} */}
                            {isDateExpired(values.second_grace_period) ? (
                                withdrawalOrder && (
                                    <Button
                                        type="submit"
                                        name={'order_withdrawal'}
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmitting}
                                        onClick={()=>{
                                            setFieldValue('order_withdrawal',true);
                                            setSaveOnly(false);
                                        }}
                                    >
                                        <Icon fontSize="small">not_interested</Icon>
                                        &nbsp;
                                        {i18n.get('deficiency.events.order_withdrawal')}
                                    </Button>
                                )
                            ) : ((
                                    (values.deadline && values.status.event === 'deficiency_notified') ||
                                    (values.first_grace_period && values.status.event === 'deadline') ||
                                    (values.second_grace_period && values.status.event === 'first_grace_period')
                                ) &&
                                <Button
                                    type="submit"
                                    name={'submitting'}
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    style={{marginLeft:10}}
                                    disabled={isSubmitting}
                                    onClick={()=>setSaveOnly(false)}
                                >
                                    <Icon fontSize="small">save</Icon>
                                    &nbsp;
                                    {i18n.get('deficiency.save_and_send')}
                                </Button>
                            )}
                            <Button
                                type="submit"
                                name={'submitter'}
                                size="small"
                                variant="contained"
                                color="primary"
                                style={{marginLeft:10}}
                                disabled={isSubmitting}
                                onClick={()=>setSaveOnly(true)}
                            >
                                <Icon fontSize="small">save</Icon>
                                &nbsp;
                                {i18n.get('deficiency.save')}
                            </Button>
                        </React.Fragment>
                    )}
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default FormFields;
